var React = require('react');

function Newarrow (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M3.02329 6.00011L7.14829 10.1251L5.96996 11.3034L0.666626 6.00011L5.96996 0.696777L7.14829 1.87511L3.02329 6.00011Z","fill":"#191C22"}));
}

Newarrow.defaultProps = {"width":"8","height":"12","viewBox":"0 0 8 12","fill":"none"};

module.exports = Newarrow;

Newarrow.default = Newarrow;
